import { HELP_CENTER_URL } from "../../util/constants";
import { LogRegLogo } from "../util/LogRegLogo";
import "./SiteFooter.scss";

export default function SiteFooter() {
  return <footer className="footer">
  <div className="logo align-start">
    <LogRegLogo/>
  </div>

  <div className="columns"> 
    <div className="discover">
      <h4>DISCOVER</h4>
      <div className="links">
        <a href="/menu/browse.do" rel="nofollow">Menus</a>
        <a href="/feature/restaurant-menu-management.html" rel="nofollow">Menu Management</a>
        <a href="/feature/digital-menu-board-solution.html" rel="nofollow">Digital Signage</a>
        <a href="/category/marketing-templates.html" rel="nofollow" className="marketing-link">Marketing</a>
        <a href="/feature/online-menu.html" rel="nofollow" className="online-link">Mobile Menus</a>
        <a href="/feature/menu-qr-code.html" rel="nofollow" className="qrs-link">QR Codes</a>
        <a href="/feature/restaurant-landing-pages.html" rel="nofollow" className="landing-link">Link Pages</a>
        <a href="/feature/menu-services.html" rel="nofollow" className="landing-link">Menu Services</a>
      </div>
    </div>

    <div className="resources">
      <h4>RESOURCES</h4>
      <div className="links">
        <a href="/feature/Print-Services.html" rel="nofollow" className="print-link">Print</a>
        <a href="/feature/case-studies.html" rel="nofollow">Case Studies</a>
        <a href="/feature/blog.html" rel="nofollow">Blog</a>
        <a href={HELP_CENTER_URL} rel="nofollow" className="help-link">Help Center</a>
        <a href="/feature/explore.html" rel="nofollow" className="explore-link">Explore</a>
      </div>
    </div>
  
    <div className="company">
      <h4>COMPANY</h4>
      <div className="links">
        <a href="/menu/pricing.do" rel="nofollow noreferrer" className="pricing-link">Pricing</a>
        <a href="/menu/about/view.do" rel="nofollow noreferrer" className="about-link">About Us</a>
        <a href="/content/press" rel="nofollow noreferrer" className="press-link">Press</a>
        <a href="/content/partners" rel="nofollow noreferrer" className="partners">Partners</a>
        <a href="/menu/contact.do" rel="nofollow noreferrer" className="contact-link">Contact</a>
        <a href="/menu/usagePolicy/view.do" rel="nofollow noreferrer" className="terms-link">Terms of Use</a>
        <a href="/menu/privacyPolicy/view.do" rel="nofollow noreferrer" className="terms-link">Privacy Policy</a>
        <a href="https://status.musthavemenus.com/" rel="nofollow noreferrer" className="terms-link" target="_blank">Status</a>
      </div>
    </div>
  </div>

  <div className="bottom-links">
    <div className="copyright add-margin add-padding">
      &#169; 2026 MustHaveMenus Inc. All Rights Reserved.<br/>
      &#169; QR Code is a registered trademark of Denso Wave Incorporated
    </div>

    <div className="icons add-margin add-padding">
      <a href="https://www.youtube.com/user/MustHaveMenusVideos" target="_blank" rel="noreferrer" title="Check us out on YouTube" aria-label="Check us out on YouTube"><img src="https://timber.mhmcdn.com/site/marketing/icons/YouTube.svg" alt="Check us out on YouTube" loading="lazy"/></a>
      <a href="https://www.facebook.com/musthavemenus/" target="_blank" rel="noreferrer" title="Follow us on Facebook" aria-label="Follow us on Facebook"><img src="https://timber.mhmcdn.com/site/marketing/icons/Facebook.svg" alt="Follow us on Facebook" loading="lazy"/></a>
      <a href="https://www.instagram.com/musthavemenus/" target="_blank" rel="noreferrer" title="Follow us on Instagram" aria-label="Follow us on Instagram"><img src="https://timber.mhmcdn.com/site/marketing/icons/Instagram.png" alt="Follow us on Instagram" loading="lazy"/></a>
      <a href="https://twitter.com/musthavemenus" target="_blank" rel="noreferrer" title="Follow us on X" aria-label="Follow us on X"><img src="https://timber.mhmcdn.com/site/marketing/icons/X.svg" alt="Follow us on X" loading="lazy"/></a>
      <a href="https://www.pinterest.com/musthavemenus/" target="_blank" rel="noreferrer" title="Follow us on Pinterest" aria-label="Follow us on Pinterest"><img src="https://timber.mhmcdn.com/site/marketing/icons/Pinterest.svg" alt="Follow us on Pinterest" loading="lazy"/></a>
    </div>
  </div>
</footer>
}